import Person from "@/types/Person.interface"

interface State {
    personsQueue: Person[]
}

const defaults = () => {
    return {
        personsQueue: []
    }
}

export default {
    state: defaults(),
    mutations: {
        personsQueueAdd (state: State, persons: Person[]): void {
            //  Grab our current persons queue or initialize to an array if it doesn't exist
            state.personsQueue = state.personsQueue || []

            //  Add the person to the list
            state.personsQueue = window.removeDuplicatesById(state.personsQueue, persons)
        },
        personsQueueClear (state: State): void {
            state.personsQueue = []
        },
        personsQueueRemove (state: State, person: Person): void {
            //  Find the person we want to remove
            const idx = state.personsQueue.findIndex(x => x.id === person.id)

            //  If the person was not found, do nothing
            if (!idx) return

            //  Else remove them from queue
            state.personsQueue.splice(idx, 1)
        },
        personsQueueReset (state: State): void {
            Object.assign(state, defaults())
        }
    },
    actions: {},
    getters: {
        personsQueue (state: State): Person[] {
            return state.personsQueue
        }
    }
}